// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3q9GK","label":"CategoryService_label__16tzy","location":"CategoryService_location__33rei"};